import React from 'react';
import teamPhoto from '../../assets/DDHAPPS/white-top-home.webp';
import PageHero from '../../components/shared/PageHero';
import TypeWriter from '../../components/shared/TypeWriter';

const s = {
  launchBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    background: '#fff',
    border: '1px solid #e5e5ea',
    borderRadius: 32,
    padding: '10px 20px',
    fontSize: 'clamp(0.78rem, 2vw, 0.88rem)',
    color: '#6b6b6b',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  launchDot: {
    width: 7, height: 7,
    borderRadius: '50%',
    background: '#34d399',
    flexShrink: 0,
  },
};

const badge = (
  <div style={s.launchBadge}>
    <span style={s.launchDot} />
    We've just launched our first app —&nbsp;
    <strong style={{ color: '#2a2a2a' }}>RiddleMe</strong>
  </div>
);

function HomeHero() {
  return (
    <PageHero
      eyebrow="Independent app developers"
      headline={<>We build <TypeWriter words={['apps', 'websites']} typeSpeeds={[130, 80]} /><br />people love.</>}
      image={teamPhoto}
      imageAlt="DDHAPPS team"
      sub="A small expert team blending professional mobile app and web development with advanced automated testing for quality assurance."
      badge={badge}
    />
  );
}

export default HomeHero;
